var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTootltipOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M17.454 4.527H5.53c-.836 0-1.53.678-1.53 1.53v8.091c0 .836.678 1.53 1.53 1.53h3.233l2.098 2.792c.316.426.947.426 1.262 0l2.114-2.808h3.233c.836 0 1.53-.678 1.53-1.53V6.057c-.016-.852-.694-1.53-1.546-1.53zm-2.113 8.217H7.644c-.442 0-.805-.362-.805-.804 0-.442.363-.805.805-.805h7.697c.441 0 .804.363.804.805.016.442-.363.804-.804.804zm0-3.675H7.644c-.442 0-.805-.363-.805-.804 0-.442.363-.805.805-.805h7.697c.441 0 .804.363.804.805 0 .441-.363.804-.804.804z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4.09,
    x2: 18.895,
    y1: 11.658,
    y2: 11.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTootltipOrange);
export default __webpack_public_path__ + "static/media/icon-tootltip-orange.909aabc5.svg";
export { ForwardRef as ReactComponent };